import { call, put, select, takeEvery, takeLatest } from "redux-saga/effects";
import { notificationApi } from "../../../api/notification/notificationApi";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { rootActions } from "../../actions/rootActions";
import {
  eNotificationActionIds,
  INotificationActionTypes,
} from "../../action-types/nofitication/INofiticationActionTypes";

const PAGE_SIZE = 20;

export function* nofiticationSaga(): any {
  yield takeLatest(eNotificationActionIds.LOAD_START, loadWorker);
  yield takeLatest(
    eNotificationActionIds.LOAD_UNREAD_COUNT_START,
    loadUnreadCountWorker,
  );
  yield takeEvery(eNotificationActionIds.MARK_READ_START, markReadWorker);
}

function* loadWorker(action: INotificationActionTypes): any {
  const payload = (action.payload as any) ?? {};
  const append = !!payload.append;
  const { readStatus, pageIndex } = yield select(
    (x: any) => x.nofitication.nofitication,
  );
  const page = append ? pageIndex + 1 : 0;

  const res: IBaseRespone = yield call(
    notificationApi.Select,
    page,
    PAGE_SIZE,
    readStatus,
  );
  if (res.is_success) {
    const data = res.data ?? {};
    yield put(
      rootActions.nofitication.nofitication.LOAD_SUCCESS({
        items: data.items ?? [],
        total_count: data.total_count ?? 0,
        unread_count: data.unread_count ?? 0,
        append,
      }),
    );
  } else {
    yield put(
      rootActions.nofitication.nofitication.LOAD_ERRR(res.message ?? "Có lỗi"),
    );
  }
}

function* loadUnreadCountWorker(): any {
  // Lấy 1 dòng chỉ để đọc unread_count cho badge.
  const res: IBaseRespone = yield call(notificationApi.Select, 0, 1, "all");
  if (res.is_success) {
    yield put(
      rootActions.nofitication.nofitication.LOAD_UNREAD_COUNT_SUCCESS(
        res.data?.unread_count ?? 0,
      ),
    );
  }
}

function* markReadWorker(action: INotificationActionTypes): any {
  const id = (action.payload as number) ?? 0;
  const res: IBaseRespone =
    id === 0
      ? yield call(notificationApi.MarkAllRead)
      : yield call(notificationApi.MarkRead, id);
  if (res.is_success) {
    yield put(rootActions.nofitication.nofitication.MARK_READ_SUCCESS(id));
  }
}
